import React, { memo } from 'react';
import { styledComponent, lineHeightStyle } from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';
import ChiefComplainDeleteBtn from '../../chiefComplainDeleteBtn';

const OncologyHistoryView = ({
  selectedHistories,
  setSelectedHistories,
  prescriptionItems,
  isHistoryPage,
  removeItemsData,
}) => {
  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  const oncology = selectedHistories?.oncology || {};

  const handleDeleteField = (fieldName) => {
    const updatedOncology = { ...oncology };
    delete updatedOncology[fieldName];

    const updatedHistories = {
      ...selectedHistories,
      oncology: updatedOncology,
    };

    setSelectedHistories(updatedHistories);
  };

  return (
    <>
      <div style={{ fontWeight: '700' }}>Oncology:</div>
      <ul style={lineHeightStyle('history', prescriptionItems)}>
        {selectedHistories?.oncology?.chemoTherapyNotes && (
          <li className="text-left">
            <Title>Chemotherapy:</Title>{' '}
            <Value>
              {selectedHistories?.oncology?.chemoTherapyNotes}{' '}
              {selectedHistories?.oncology?.chemoTherapyDate
                ? selectedHistories?.oncology?.chemoTherapyDate
                : ''}
            </Value>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'oncology'}
                delId={'chemoTherapyNotes'}
              />
            )}
          </li>
        )}
        {selectedHistories?.oncology?.radioTherapyNotes && (
          <li className="text-left">
            <Title>Radiotherapy:</Title>{' '}
            <Value>
              {selectedHistories?.oncology?.radioTherapyNotes}{' '}
              {selectedHistories?.oncology?.radioTherapyDate
                ? selectedHistories?.oncology?.radioTherapyDate
                : ''}
            </Value>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'oncology'}
                delId={'radioTherapyNotes'}
              />
            )}
          </li>
        )}
        {selectedHistories?.oncology?.hormonalTherapyNotes && (
          <li className="text-left">
            <Title>Hormonal Therapy:</Title>{' '}
            <Value>
              {selectedHistories?.oncology?.hormonalTherapyNotes}{' '}
              {selectedHistories?.oncology?.hormonalTherapyDate
                ? selectedHistories?.oncology?.hormonalTherapyDate
                : ''}
            </Value>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'oncology'}
                delId={'hormonalTherapyNotes'}
              />
            )}
          </li>
        )}
        {selectedHistories?.oncology?.surgeryNotes && (
          <li className="text-left">
            <Title>Surgery:</Title>{' '}
            <Value>
              {selectedHistories?.oncology?.surgeryNotes}{' '}
              {selectedHistories?.oncology?.surgeryDate
                ? selectedHistories?.oncology?.surgeryDate
                : ''}
            </Value>
            {!isHistoryPage && (
              <ChiefComplainDeleteBtn
                action={removeItemsData}
                itemName={'oncology'}
                delId={'surgeryNotes'}
              />
            )}
          </li>
        )}
      </ul>
    </>
  );
};

export default memo(OncologyHistoryView);
